import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { Languages, Check } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import i18n, { LANGUAGES, setLanguage } from "@/i18n";

/** Selettore lingua dell'interfaccia: vale solo per l'utente collegato. */
export function LanguageCard() {
  const { t, i18n } = useTranslation();
  const { updateUser } = useAuth();
  const [saving, setSaving] = useState(null);

  const choose = async (code) => {
    if (code === i18n.language) return;
    setSaving(code);
    setLanguage(code);
    const tt = i18n.getFixedT(code);
    try {
      await api.patch("/auth/me", { language: code });
      updateUser({ language: code });
      toast.success(tt("settings.language.updated"));
    } catch {
      toast.error(tt("settings.language.error"));
    } finally {
      setSaving(null);
    }
  };

  return (
    <div className="pt-4 border-t border-[color:var(--sp-border)]" data-testid="settings-language">
      <div className="label-eyebrow mb-1 flex items-center gap-1">
        <Languages className="h-3 w-3" /> {t("settings.language.title")}
      </div>
      <p className="text-xs text-[color:var(--sp-text-muted)] mb-3">
        {t("settings.language.description")}
      </p>
      <div className="flex flex-wrap gap-2">
        {LANGUAGES.map((l) => {
          const active = i18n.language === l.code;
          return (
            <button
              key={l.code}
              type="button"
              onClick={() => choose(l.code)}
              disabled={saving === l.code}
              data-testid={`language-option-${l.code}`}
              aria-pressed={active}
              className={`inline-flex items-center gap-2 px-3.5 py-2 rounded-full border text-sm font-bold transition-colors ${
                active
                  ? "border-[color:var(--sp-brand)] bg-[color:var(--sp-brand)]/10 text-[color:var(--sp-brand)]"
                  : "border-[color:var(--sp-border)] hover:bg-[color:var(--sp-subtle)]"
              }`}
            >
              <span aria-hidden>{l.flag}</span> {l.label}
              {active && <Check className="h-3.5 w-3.5" />}
            </button>
          );
        })}
      </div>
    </div>
  );
}
